import { AddressTile } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/AddressTile.tsx';
import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { AddressDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/PersonAddress/AddressDrawer/AddressDrawer.tsx';
import { ConfirmDeleteDrawer } from '@dealstack/frontend/shared/components/ConfirmDeleteDrawer/ConfirmDeleteDrawer.tsx';
import { usePersonAddressesController } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/PersonAddress/usePersonAddressesController.ts';

interface Props {
	hasEditorPermission: boolean;
	onAddAddress: () => void;
}

export const PersonAddresses = ({ hasEditorPermission, onAddAddress }: Props) => {
	const tCapManage = useTranslationCapManage();
	const {
		selectedAddress,
		setSelectedAddress,
		setSelectedDeleteAddress,
		selectedDeleteAddress,
		onAddressDelete,
		deleteLoading,
		selectedEntityData,
	} = usePersonAddressesController();

	return selectedEntityData?.addresses?.length ? (
		<EditableInfoContainer
			title={tCapManage('basic_details.address_form.address_label')}
			onAdd={onAddAddress}
			childrenPadding="0.5rem"
			useGrid={true}
		>
			{selectedEntityData.addresses.map((address) => (
				<AddressTile
					key={address.id}
					address={address}
					hasEditorPermission={hasEditorPermission}
					onEditClick={() => setSelectedAddress(address)}
					onDeleteClick={() => setSelectedDeleteAddress(address)}
				/>
			))}

			<AddressDrawer
				opened={!!selectedAddress}
				onClose={() => setSelectedAddress(null)}
				address={selectedAddress}
				hasPermission={hasEditorPermission}
			/>

			<ConfirmDeleteDrawer
				opened={!!selectedDeleteAddress}
				onClose={() => setSelectedDeleteAddress(null)}
				title={tCapManage('delete.address.drawer.title')}
				inputLabel={tCapManage('delete.address.drawer.inputLabel')}
				inputPlaceholder={tCapManage('delete.address.drawer.inputPlaceholder')}
				confirmDeleteText={selectedDeleteAddress?.singleAddressString ?? 'Delete address'}
				wordMismatchErrorMessage={tCapManage('delete.address.drawer.wordMismatchError')}
				deleteBtnText={tCapManage('delete.entity.drawer.confirmDelete')}
				cancelBtnText={tCapManage('delete.entity.drawer.cancel')}
				handleDelete={onAddressDelete}
				deleteLoading={deleteLoading}
			/>
		</EditableInfoContainer>
	) : null;
};
